import Helper from "./Helper";

class Cv {
  constructor() {
    this.cvsToggler = document.querySelectorAll(".ns-cv__toggle");
    this.cvText = document.querySelectorAll(".ns-cv__line-text");
    this.cv = document.querySelectorAll(".ns-cv");
    this.iconPlus = document.querySelectorAll(".svg-plus");
    this.iconMinus = document.querySelectorAll(".svg-minus");
    this.cvsTogglerArray = Array.prototype.slice.call(this.cvsToggler);
    this.bindEvents();
  }


  bindEvents() {
    this.cv.forEach((cvItem) => {
      cvItem.addEventListener("click", (e) => {
        Helper.toggleClass(cvItem, "active");
        Helper.toggleClass(cvItem, "open");

        const iconPlus = cvItem.querySelector(".svg-plus");
        const iconMinus = cvItem.querySelector(".svg-minus");

        if (cvItem.classList.contains("open")) {

          let oldText = cvItem.querySelector(".ns-cv__line-text").innerHTML;
          let newText = oldText.replace("More", "Less");
          cvItem.querySelector(".ns-cv__line-text").innerHTML = newText;

          iconPlus.style.display = "none";
          iconMinus.style.display = "block"

        } else {
          let oldText = cvItem.querySelector(".ns-cv__line-text").innerHTML;
          let newText = oldText.replace("Less", "More");
          cvItem.querySelector(".ns-cv__line-text").innerHTML = newText;

          iconPlus.style.display = "block";
          iconMinus.style.display = "none"
        }
      });
    });
  }
}

export default Cv;
